import { useAuthStore } from '~~/stores/auth'

// Network failure (offline, tab resumed from sleep, navigation): tag as cancel so pageError skips the dialog
const silenceNetworkError = (error) => {
    if (error?.name === 'FetchError' && !error.response) {
        error.cause = '__abc_http_cancel'
    }
    throw error
}

export const api = () => {
    const auth = useAuthStore()

    const fetch = (url, options = {}) => {
        const api = auth.makeApiWrapper()
        return api(url, options).catch(silenceNetworkError)
    }

    const raw = (url, options = {}) => {
        const api = auth.makeApiWrapper()
        return api.raw(url, options).catch(silenceNetworkError)
    }

    return {
        $get (url, query = {}, options = {}) {
            return (options.download || options.responseType === 'blob')
                ? raw(url, { query, ...options, method: 'GET' })
                : fetch(url, { query, ...options, method: 'GET' })
        },

        $post (url, body = {}, options = {}) {
            return (options.download || options.responseType === 'blob')
                ? raw(url, { body, ...options, method: 'POST' })
                : fetch(url, { body, ...options, method: 'POST' })
        },

        $patch (url, body = {}, options = {}) {
            return fetch(url, { body, ...options, method: 'PATCH' })
        },

        $put (url, body = {}, options = {}) {
            return fetch(url, { body, ...options, method: 'PUT' })
        },

        $delete (url, query = {}, options = {}) {
            return fetch(url, { query, ...options, method: 'DELETE' })
        }
    }
}

export const currentCreche = () => {
    const auth = useAuthStore()

    return auth.currentCreche
}

export const currentOrganization = () => {
    const auth = useAuthStore()

    return auth.organization
}
